// Helper function to convert number to Indian rupee words
export const numberToIndianWords = (num) => {
  if (!num || isNaN(num)) return '';
  
  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
    'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  
  const numToWords = (n) => {
    if (n < 20) return ones[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '');
    if (n < 1000) return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + numToWords(n % 100) : '');
    return '';
  };
  
  const n = Math.floor(parseFloat(num));
  if (n === 0) return 'Zero';
  if (n < 0) return 'Negative ' + numberToIndianWords(-n);
  
  let result = '';
  let remaining = n;
  
  if (remaining >= 10000000) {
    result += numToWords(Math.floor(remaining / 10000000)) + ' Crore ';
    remaining = remaining % 10000000;
  }
  
  if (remaining >= 100000) {
    result += numToWords(Math.floor(remaining / 100000)) + ' Lakh ';
    remaining = remaining % 100000;
  }
  
  if (remaining >= 1000) {
    result += numToWords(Math.floor(remaining / 1000)) + ' Thousand ';
    remaining = remaining % 1000;
  }
  
  if (remaining > 0) {
    result += numToWords(remaining);
  }
  
  return result.trim() + ' Rupees';
};

// Helper function to format number in short Indian format (e.g., 1.5 Cr, 50 L)
export const formatIndianShort = (num) => {
  if (!num || isNaN(num)) return '';
  const n = parseFloat(num);
  
  if (n >= 10000000) {
    return '\u20B9' + (n / 10000000).toFixed(2) + ' Cr';
  } else if (n >= 100000) {
    return '\u20B9' + (n / 100000).toFixed(2) + ' L';
  } else if (n >= 1000) {
    return '\u20B9' + (n / 1000).toFixed(2) + ' K';
  }
  return '\u20B9' + n.toLocaleString('en-IN');
};
